import { Button, useTheme } from '@mui/material'
import { modalVar } from '../../../providers/apollo/cache'
import Crown from '../../../svg/Crown'
import useBucket from '../hooks/useBucket'

export default function UpgradeButton() {
  const theme = useTheme()
  const { currentUserIsOwner } = useBucket()
  const groupsyPink = theme.palette.groupsyPink[600]
  return (
    <Button
      variant="outlined"
      sx={{
        borderRadius: 100,
        borderColor: groupsyPink,
        backgroundColor: '#FFFFFF',
        '&:hover': {
          backgroundColor: '#FFFFFF'
        }
      }}
      color="groupsy"
      onClick={() => modalVar(currentUserIsOwner ? 'upsellModal' : 'premiumFeature')}
      startIcon={<Crown sx={{ display: 'flex' }} color={groupsyPink} />}
    >
      Upgrade
    </Button>
  )
}
